import React, { useState } from "react";
import "./BriefFormGroup.css"; // Import CSS for styling
import { isRequired } from "./BriefUtils";
import deleteIcon from "../../assets/images/icons/delete.svg";
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';
// const criteriaList = [
//   "Originality",
//   "Clarity",
//   "Narrative Pace",
//   "Characters",
//   "Structure",
//   "Relevance",
//   "Creativity",
//   "Emotional Impact",
//   "Technical quality",
//   "Consistency",
// ];

const BriefFormGroup = ({
  criteriaList,
  data,
  value,
  saveAction,
  addCriterionAction,
  handleCheckboxAction,
  handleEvaluationCriteria,
}) => {
  const { Globals } = useLanguage();
  const [formData, setFormData] = useState({
    CRITERIA: value?.criteriaIds || [],
    EXTRA_CRITERIA:
      value?.customCriteriaList && value?.customCriteriaList.length !== 0
        ? value?.customCriteriaList
        : [
            {
              customCriteriaId: 0,
              customCriteriaName: "",
            },
          ],
  });

  const handleDelete = (index) => {
    setFormData((prevData) => {
      const newExtraCriteria = [...prevData.EXTRA_CRITERIA];
      newExtraCriteria.splice(index, 1);
      const currentFormData = { ...prevData, EXTRA_CRITERIA: newExtraCriteria };
      handleEvaluationCriteria(currentFormData);
      return currentFormData;
    });
  };

  const addCriterion = () => {
    setFormData((prevData) => {
      if (prevData.EXTRA_CRITERIA.length <= 2) {
        const currentFormData = {
          ...prevData,
          EXTRA_CRITERIA: [
            ...prevData.EXTRA_CRITERIA,
            { customCriteriaId: 0, customCriteriaName: "" },
          ],
        };
        handleEvaluationCriteria(currentFormData);
        return currentFormData;
      }

      handleEvaluationCriteria(prevData);
      return prevData;
    });
  };

  const handleCheckbox = (type, value, seletedValue) => {
    const { checked } = value.target;
    const { criteriaId } = seletedValue;
    setFormData((prevData) => {
      const newCriteria = checked
        ? [...prevData.CRITERIA, criteriaId]
        : prevData.CRITERIA.filter((item) => item !== criteriaId);
      const updateFormData = { ...prevData, CRITERIA: newCriteria };
      handleEvaluationCriteria(updateFormData);
      return updateFormData;
    });
    handleCheckboxAction(type, value);
  };

  const handleInputBox = (e, index, criterion) => {
    const { value } = e.target;
    setFormData((prevData) => {
      const newExtraCriteria = [...prevData.EXTRA_CRITERIA];
      criterion.customCriteriaName = value;
      newExtraCriteria[index] = criterion;
      const updateData = { ...prevData, EXTRA_CRITERIA: newExtraCriteria };
      handleEvaluationCriteria(updateData);
      return updateData;
    });
  };

  return (
    <div className="brief-form-container">
      <div className="brief-criteria-header">
        {isRequired(Globals.CREATE_NEW_BRIEF.EVALUATION_CRITERIA, true)}
      </div>
      <div className="brief-form-container-criteria">
        <div className="brief-form-content">
          {/* First container: Checkbox with text */}
          <div className="brief-checkbox-column">
            {criteriaList.map((item, index) => {
              return (
                <div
                  key={index}
                  className="brief-checkbox-item brief-margin-row"
                >
                  <input
                    type="checkbox"
                    id={`brief-checkbox-${index}`}
                    onClick={(value) => handleCheckbox(1, value, item)}
                    checked={formData?.CRITERIA?.includes(item.criteriaId)}
                  />
                  <label htmlFor={`brief-checkbox-${index}`}>
                    {item.criteriaName}
                  </label>
                </div>
              );
            })}
          </div>
          {/* Second container: Input text field and Save button */}
          <div className="brief-input-column">
            <label className="brief-optional-label brief-input-top-label-brief">
              {Globals.CREATE_NEW_BRIEF.CRITERIA_NAME}
            </label>

            {/* Additional Criteria Input Fields */}
            {formData.EXTRA_CRITERIA.map((criterion, index) => {
              return (
                <div key={index} className="brief-input-save extra-criteria">
                  <input
                    type="text"
                    placeholder=' '
                    className="brief-input-box"
                    value={criterion?.customCriteriaName}
                    onChange={(e) => handleInputBox(e, index, criterion)}
                  />
                  <button
                    className={`${
                      index !== 0 ? "brief-delete-btn" : "brief-delete-btn hide"
                    }`}
                    onClick={() => handleDelete(index)}
                  >
                    <img class="delete-img" src={deleteIcon}></img>
                  </button>
                </div>
              );
            })}

            {/* Add Criterion Button Below Input */}
            {formData.EXTRA_CRITERIA.length <= 2 && (
              <div className="brief-add-criterion">
                <button className="brief-add-link" onClick={addCriterion}>
                  {Globals.CREATE_NEW_BRIEF.ADD_CRITERION}
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="brief-form-content"></div>
      </div>
    </div>
  );
};

export default BriefFormGroup;
